export default __webpack_public_path__ + "static/media/esg-51.e31d4b20.jpg";